import { BaseService } from './base.service'

import axios from '@axios'

import { ResponseWrapper, ErrorWrapper } from './util'

// const axiosInsBase = axios.create({
//   baseURL: '/',
//   headers: {
//     Accept: 'application/json',
//     'x-user-type': 'ADMIN',
//   },
// })

export class UicomponentService extends BaseService {
  static get entity () {
    return '/uicomponent/filter/'
  }

  static async findAll (parameters = {}, type) {

    const params = { ...parameters }
    try {

      const response = await axios.get(`${this.entity}${type}`, { params })

      // NOT FOUND
      if (response.data.code == '06') {
        const message = response.data.message
        errorNotification(Vue, "Oops!", message);
        throw new ErrorWrapper(error, message)
      }

      const data = {
        content: response.data.data,
        total: Number(response.data.data.totalElements)
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.message : error.response.statusText
      errorNotification(Vue, "Oops!", message);

      throw new ErrorWrapper(error, message)
    }
  }
}
